import { getCockpitUser } from "../auth-provider";
import { useAsync } from "react-async";
import { CockpitUser } from "../api";

export type UseCockpitUserResult = {
    user?: CockpitUser;
    isLoading: boolean;
    error?: Error;
};

export const useCockpitUser = (): UseCockpitUserResult => {
    const { data: user, isLoading, error } = useAsync({ promiseFn: getCockpitUser });
    return {
        user,
        isLoading,
        error,
    };
};
